/**
 * Whether the demand note form and the payment screens show the Due Date.
 * Hidden on Bahadura: the due date is no longer asked for or printed.
 * Set to true to bring it back.
 */
export const SHOW_DEMAND_NOTE_DUE_DATE = false;
